<template>
  <div class="feedback-group-wrapper">
    <div class="feedback-group-inner header border-bottom">
      <h2>{{is_active ? "Účastníci" : "Pridajte účastníkov prieskumu"}}</h2>
    </div>
    <div class="feedback-group-inner form-wrapper">
      <div v-if="!is_active && !is_editing_participants">
        <div class="add-participant-form">
          <input class="input-text" placeholder="Email*" v-model="addParticipantEmail" />
          <input class="input-text" placeholder="Meno*" v-model="addParticipantFirstName" />
          <input class="input-text" placeholder="Priezvisko*" v-model="addParticipantLastName" />
          <button class="button" @click="addParticipant">Pridať účastníka</button>
        </div>
        <div class="import-participants-wrapper">
          <span>alebo</span>
          <button class="button dashed w-100" @click="changeExcelFile">+ Importovať z excelu</button>
          <input
                  type="file"
                  ref="fileInput"
                  style="display:none"
                  accept=".xlsx"
                  @change="importParticipantsExcel"
          />
        </div>

        <div>
          <div class="feedback-group-inner header border-bottom flex-row">
            <h4>Zoznam vami pridaných účastníkov</h4>
            <a class="inline" @click="toggleShow">
              {{!show_participants ? "Zobraziť účastníkov" : "Skryť účastníkov"}}
              <span
                      v-bind:class="[!show_participants ? 'ico-caret-down-black' : 'ico-caret-up-black']"
              ></span>
            </a>
          </div>
          <div v-if="!!show_participants" class="feedback-group-inner table-participants">
            <table>
              <tbody>
              <tr
                      v-for="participant in newParticipants"
                      :key="participant.uid"
                      :class="{errorRow: !participant.valid}"
              >
                <td
                        v-if="matchParticipants(participant, editParticipant)"
                        @x-dblclick="handleEditParticipant(participant)"
                >
                  <input v-model="editParticipant.email" />
                </td>
                <td v-else>{{participant.email}}</td>

                <td
                        v-if="matchParticipants(participant, editParticipant)"
                        @x-dblclick="handleEditParticipant(participant)"
                >
                  <input v-model="editParticipant.name" />
                </td>
                <td v-else>{{participant.name}}</td>

                <td
                        v-if="matchParticipants(participant, editParticipant)"
                        @x-dblclick="handleEditParticipant(participant)"
                >
                  <input v-model="editParticipant.lastname" />
                </td>
                <td v-else>{{participant.lastname}}</td>

                <td>
                  <a
                          v-if="matchParticipants(participant, editParticipant)"
                          @click="handleSaveParticipant()"
                  >
                    <span class="ico-save"></span>
                  </a>
                  <a v-else @click="handleEditParticipant(participant)">
                    <span class="ico-edit"></span>
                  </a>
                  <a @click="handleDeleteParticipant(participant)">
                    <span class="ico-close-red-small"></span>
                  </a>
                </td>
              </tr>

              <tr v-for="participant in existingParticipants" :key="participant.participationId">
                <td v-if="matchParticipants(participant, editParticipant)">
                  <input v-model="editParticipant.email" />
                </td>
                <td v-else @x-dblclick="handleEditParticipant(participant)">{{participant.email}}</td>

                <td v-if="matchParticipants(participant, editParticipant)">
                  <input v-model="editParticipant.name" />
                </td>
                <td v-else>{{participant.name}}</td>

                <td v-if="matchParticipants(participant, editParticipant)">
                  <input v-model="editParticipant.lastname" />
                </td>
                <td v-else>{{participant.lastname}}</td>

                <td>
                  <a
                          v-if="matchParticipants(participant, editParticipant)"
                          @click="handleSaveParticipant()"
                  >
                    <span class="ico-save"></span>
                  </a>
                  <a v-else @click="handleEditParticipant(participant)">
                    <span class="ico-edit"></span>
                  </a>
                  <a @click="handleDeleteParticipant(participant)">
                    <span class="ico-close-red-small"></span>
                  </a>
                </td>
              </tr>

              <tr v-if="participants.length == 0">Zatiaľ neboli pridaní účastníci</tr>
              </tbody>
            </table>
            <div class="participants-footer">
              <span
                      class="text-red error-message"
              >Prosíme skontrolujte správne zadané údaje vo vyznačených riadkoch</span>
              <button class="button big" @click="reloadParticipants">Prejsť ďalej a vyplniť vzťahy</button>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="feedback-group-inner table-participants-status">
        <table class="participants-table">
          <tbody>
          <template v-for="participant in existingParticipants">
            <tr :key="participant.participationId" v-if="!is_active || relationsByEvaluated[participant.customerId].length" class="participant">
              <td><span class="bold">Hodnotený</span></td>
              <td><span class="bold">{{participant.email}}</span></td>
              <td><span class="bold">{{participant.name}}</span></td>
              <td><span class="bold">{{participant.lastname}}</span></td>
              <td v-if="is_active">
                  <span class="text-red inline" @click="toggleOpenParticipant(participant.participationId)">
                  {{!openParticipants[participant.participationId] ? "Zobraziť hodnotiacich" : "Skryť hodnotiacich"}}
                  <span
                          v-bind:class="[!openParticipants[participant.participationId] ? 'ico-caret-down-red' : 'ico-caret-up-red']"
                  ></span>
                </span>
              </td>
            </tr>
            <tr v-for="relationType in relationTypes" :key="participant.participationId + ' ' + relationType.id" v-if="openParticipants[participant.participationId] && relationsByEvaluated[participant.customerId].filter(r => r.role_id == relationType.id).length">
              <td>{{relationType.name}}</td>
              <FeedbackViewRelations :relationType="relationType"
                                     :relations="relationsByEvaluated[participant.customerId]"
                                     :participantById="participantById"/>
            </tr>
          </template>
          <tr v-if="participants.length == 0">Zatiaľ neboli pridaní účastníci</tr>
          </tbody>
        </table>
        <div class="participants-footer">
        </div>
      </div>
    </div>
  </div>
</template>

<style type="text/css">
  .bold{
    font-weight: bold;
  }

  .participants-table{
    border-collapse: collapse;
    border-left: 1px solid #e1e1e1;
    border-right: 1px solid #e1e1e1;
    border-bottom: 1px solid #e1e1e1;
  }
  .participants-table .participant{
    border-top: 1px solid #e1e1e1;
  }

  .participants-table td{
    padding: 10px;
  }
</style>

<script>
  import FormBase from "../../elements/FormBase";
  import XLSX from "xlsx";
  import { mapState } from "vuex";
  import { generateUUID } from "./uuid";
  import feedbackApi from "../../api/feedback";
  import FeedbackViewRelations from "./FeedbackViewRelations"

  const participantsCompare = (a, b) => {
    if (!a) {
      return 1;
    }
    if (!b) {
      return -1;
    }

    const validity = !b.valid - !a.valid;
    const newer =
            (typeof a.customerId === "undefined") -
            (typeof b.customerId === "undefined");

    const newer2 =
            (typeof a.participationId === "undefined") -
            (typeof b.participationId === "undefined");

    const fromThisRun = !!b.fromThisRun - !!a.fromThisRun;

    if (validity !== 0) {
      return validity;
    }

    if (newer !== 0) {
      return newer;
    }

    if (newer2 !== 0) {
      return newer2;
    }

    if (fromThisRun !== 0) {
      return fromThisRun;
    }

    return (a.email > b.email) - (b.email > a.email);
  };

  export default {
    props: ["is_active", "is_editing_participants", "courseId"],
    components: {FeedbackViewRelations},
    mixins: [FormBase],
    data: function() {
      return {
        show_participants: false,
        addParticipantEmail: "",
        addParticipantFirstName: "",
        addParticipantLastName: "",
        editParticipant: null,
        newParticipants: [],
        deletedExistingParticipants: [],
        openParticipants: {}
      };
    },
    computed: {
      ...mapState({
        participants: state => state.feedback.participants,
        relationTypes: state => state.feedback.relationTypes,
        participantById: state =>
                state.feedback.participants.reduce((out, p) => {
                  return { ...out, [p.customer_id]: p };
                }, {}),

        relationsByEvaluated(state) {
          var result = state.feedback.participants.reduce(
                  (accumulator, participant) => {

                    let relations = state.feedback.relations
                            .filter(fr => fr.evaluated_id == participant.customer_id)
                            .map(fr => ({
                              ...fr,
                              evaluating: state.feedback.participants.find(
                                      x => fr.evaluating_id === x.customer_id
                              )
                            }));
                      return {
                        ...accumulator,
                        [participant.customer_id]: relations
                      }
                  },
                {}
          );
          return result;
        }
      }),
      existingParticipants() {
        return this.participants
                .filter(
                        p =>
                                !this.newParticipants
                                        .map(np => np.customerId)
                                        .includes(p.customer_id) &&
                                !this.deletedExistingParticipants.includes(p.id)
                )
                .map(p => ({
                  participationId: p.id,
                  customerId: p.customer_id,
                  email: p.customer.email,
                  name: p.customer.name,
                  lastname: p.customer.lastname,
                  courseId: p.course_id
                }))
                .sort(participantsCompare);
      }
    },
    methods: {
      toggleOpenParticipant(participantId) {
        this.openParticipants = { ...this.openParticipants, [participantId]: !this.openParticipants[participantId] };
      },
      matchParticipants(a, b) {
        return (
                !!a &&
                !!b &&
                ((!!a.participationId && a.participationId === b.participationId) ||
                        (!!a.customerId && a.customerId === b.customerId) ||
                        (!!a.uid && a.uid == b.uid))
        );
      },
      clearAddParticipant() {
        this.addParticipantEmail = "";
        this.addParticipantFirstName = "";
        this.addParticipantLastName = "";
      },
      apiPostEditParticipant({
                               customerId,
                               uid,
                               participationId,
                               email,
                               firstName,
                               lastName,
                               courseId
                             }) {
        const dto = { customerId, uid, email, firstName, lastName, courseId };
        const newParticipant = {
          participationId,
          customerId,
          uid,
          email,
          name: firstName,
          lastname: lastName,
          courseId,
          fromThisRun: true
        };
        return feedbackApi.postEditParticipant(dto).then(
                result => {
                  newParticipant.valid = result.status == 200 && !!result.data.ok;

                  if (!!result.data.output.participation_id) {
                    newParticipant.participationId =
                            result.data.output.participation_id;
                  }
                  if (!!result.data.output.customer_id) {
                    newParticipant.customerId = result.data.output.customer_id;
                  }

                  const idx = this.newParticipants.findIndex(v =>
                          this.matchParticipants(v, newParticipant)
                  );
                  this.$set(
                          this.newParticipants,
                          idx > -1 ? idx : this.newParticipants.length,
                          newParticipant
                  );

                  this.newParticipants.sort(participantsCompare);
                  this.clearAddParticipant();
                },
                err => {
                  newParticipant.valid = false;
                  const idx = this.newParticipants.findIndex(v =>
                          this.matchParticipants(v, newParticipant)
                  );
                  this.$set(
                          this.newParticipants,
                          idx > -1 ? idx : this.newParticipants.length,
                          newParticipant
                  );
                  this.clearAddParticipant();
                }
        );
      },

      handleEditParticipant(participant) {
        this.editParticipant = {
          participationId: participant.participationId,
          customerId: participant.customerId,
          uid: participant.uid || generateUUID(),
          email: participant.email,
          name: participant.name,
          lastname: participant.lastname
        };
      },
      handleSaveParticipant() {
        this.apiPostEditParticipant({
          customerId: this.editParticipant.customerId,
          participationId: this.editParticipant.participationId,
          uid: this.editParticipant.uid,
          email: this.editParticipant.email,
          firstName: this.editParticipant.name,
          lastName: this.editParticipant.lastname,
          courseId: this.courseId
        }).then(result => {
          this.editParticipant = null;
        });
      },

      importParticipant(participantData) {
        const newParticipant = { ...participantData, uid: generateUUID() };

        const newParticipantDTO = {
          courseId: this.courseId,
          uid: newParticipant.uid,
          participationId: newParticipant.participationId,
          customerId: newParticipant.customerId,
          email: newParticipant.email,
          firstName: newParticipant.name,
          lastName: newParticipant.lastname
        };

        this.apiPostEditParticipant(newParticipantDTO).then(
                result => {
                  console.dir(result);
                },
                err => {
                  console.dir(err);
                }
        );
      },

      addParticipant() {
        const newParticipant = {
          email: this.addParticipantEmail,
          name: this.addParticipantFirstName,
          lastname: this.addParticipantLastName
        };

        this.importParticipant(newParticipant);
      },

      handleDeleteParticipant(participant) {
        if (participant.customerId) {
          feedbackApi
                  .postDeleteParticipantLink({
                    participationId: participant.participationId,
                    customerId: participant.customerId,
                    courseId: this.courseId
                  })
                  .then(
                          result => {
                            this.deletedExistingParticipants = [
                              ...this.deletedExistingParticipants,
                              participant.participationId
                            ];
                          },
                          err => {}
                  );
        } else {
          this.newParticipants = this.newParticipants.filter(
                  p => !this.matchParticipants(p, participant)
          );
        }
      },

      toggleShow() {
        this.show_participants = !this.show_participants;
      },

      changeExcelFile() {
        this.$refs.fileInput.click();
      },

      importParticipantsExcel(event) {
        const files = event.target.files;
        if (files[0] !== undefined) {
          const fr = new FileReader();
          fr.readAsBinaryString(files[0]);
          fr.addEventListener("load", e => {
            var workbook = XLSX.read(e.target.result, { type: "binary" });
            var first_sheet_name = workbook.SheetNames[0];
            var worksheet = workbook.Sheets[first_sheet_name];
            var data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            var ctx = {};
            for (var i in data) {
              if (data[i][0] && data[i][1] && data[i][2]) {
                this.importParticipant({
                  email: data[i][0],
                  name: data[i][1],
                  lastname: data[i][2]
                });
              }
            }

            if (data.length > 0) {
              this.$api.toaster.success({ txt: "Účastníci úspešne importovaní" });
            }
          });
        }
      },
      reloadParticipants() {
        this.$store.dispatch("feedback/loadFeedback");
        this.show_participants = false;
      }
    }
  };
</script>

<style lang="less" scoped>
  .errorRow {
    color: #b11116;
  }
  progress {
    /* Reset the default appearance */
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: none;
    display: block;

    background: black;
    color: #b11116;
    width: 100%;
    height: 5px;

    &::-webkit-progress-bar {
      background: #e1e1e1;
    }
    &::-webkit-progress-value {
      background: linear-gradient(90deg, #b11116, #ea3b40);
    }
    &::-moz-progress-bar {
      background: linear-gradient(90deg, #b11116, #ea3b40);
    }
  }
</style>



// WEBPACK FOOTER //
// src/public_app/pages/feedback/FeedbackEditParticipants.vue